import { maxName, minName, validations } from "../../../../../config/validations/validations";
export const rules: any = {
    name: (field?: string) => [
        validations.required.text(field),
        validations.min.text(minName),
        validations.max.text(maxName)
    ],
}